// 绑卡渠道
export var ECardChannel;

/**
 * 绑卡状态枚举
 */
(function (ECardChannel) {
  ECardChannel["checkout"] = "checkout";
  ECardChannel["stripe"] = "stripe";
})(ECardChannel || (ECardChannel = {}));
export var EBindStatus;
(function (EBindStatus) {
  EBindStatus[EBindStatus["INIT"] = 0] = "INIT";
  EBindStatus[EBindStatus["PROCESSING"] = 100] = "PROCESSING";
  EBindStatus[EBindStatus["SUCCEEDED"] = 200] = "SUCCEEDED";
  EBindStatus[EBindStatus["FAILED"] = 300] = "FAILED";
  EBindStatus[EBindStatus["EXPIRED"] = 400] = "EXPIRED";
  EBindStatus[EBindStatus["UN_BIND"] = 500] = "UN_BIND";
  EBindStatus[EBindStatus["UN_KNOW"] = 600] = "UN_KNOW";
})(EBindStatus || (EBindStatus = {}));
// 页面模式
export var EPageMode; // 大陆地区以外
(function (EPageMode) {
  EPageMode["CN_HAS_BINDED"] = "CN_HAS_BINDED";
  EPageMode["CN_HAS_UNBINDED"] = "CN_HAS_UNBINDED";
  EPageMode["CN_EXCEPT"] = "CN_EXCEPT";
})(EPageMode || (EPageMode = {}));
export var EEvent;

// 下单操作的标识
(function (EEvent) {
  EEvent["ON_PERIOD_CHANGED"] = "ON_PERIOD_CHANGED";
  EEvent["ON_PAY_VALIDATE_FPX"] = "ON_PAY_VALIDATE_FPX";
  EEvent["ON_VALIDATE_FAIL_FPX"] = "ON_VALIDATE_FAIL_FPX";
  EEvent["ON_PAY_WITH_FPX"] = "ON_PAY_WITH_FPX";
  EEvent["ON_PAY_FAIL_FPX"] = "ON_PAY_FAIL_FPX";
  EEvent["ON_VALIDATE_FAIL_XENDIT"] = "ON_VALIDATE_FAIL_XENDIT";
  EEvent["ON_PAY_FAIL_XENDIT"] = "ON_PAY_FAIL_XENDIT";
  EEvent["ON_PAY_VALIDATE_XENDIT"] = "ON_PAY_VALIDATE_XENDIT";
  EEvent["ON_PAY_WITH_XENDIT"] = "ON_PAY_WITH_XENDIT";
  EEvent["ON_PAY_AND_BIND_CLICK"] = "ON_PAY_AND_BIND_CLICK";
  EEvent["ON_PAY_SUCCESS"] = "ON_PAY_SUCCESS";
  EEvent["ON_REFRESH"] = "ON_REFRESH";
})(EEvent || (EEvent = {}));
export var ECreateSubStatus;
(function (ECreateSubStatus) {
  ECreateSubStatus["SUCCESS"] = "SUCCESS";
  ECreateSubStatus["FAIL"] = "FAIL";
  ECreateSubStatus["BREAK"] = "BREAK";
})(ECreateSubStatus || (ECreateSubStatus = {}));